import React from 'react'
import Box from '@mui/material/Box'
import { HtmlText } from '../components/HtmlText'

const Requisites = () => {
  return (
    <Box>
      <HtmlText name={'requisites'} />
    </Box>
  )
}

export default Requisites
